import React, { useEffect, useState } from 'react';
import { Check, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const people = [{
  name: 'Julián Cabrera',
  city: 'Neuquén',
  province: 'Neuquén'
}, {
  name: 'María González',
  city: 'CABA',
  province: 'Buenos Aires'
}, {
  name: 'Laura Fernández',
  city: 'La Plata',
  province: 'Buenos Aires'
}, {
  name: 'Ana Martínez',
  city: 'Córdoba',
  province: 'Córdoba'
}, {
  name: 'Sofía López',
  city: 'Rosario',
  province: 'Santa Fe'
}, {
  name: 'Lucía Pérez',
  city: 'Mendoza',
  province: 'Mendoza'
}, {
  name: 'Martín Romero',
  city: 'Mar del Plata',
  province: 'Buenos Aires'
}, {
  name: 'Camila Sosa',
  city: 'Salta',
  province: 'Salta'
}, {
  name: 'Diego Torres',
  city: 'San Juan',
  province: 'San Juan'
}, {
  name: 'Valeria Ruiz',
  city: 'Tucumán',
  province: 'Tucumán'
}, {
  name: 'Federico Díaz',
  city: 'Bahía Blanca',
  province: 'Buenos Aires'
}, {
  name: 'Carolina Gómez',
  city: 'Santa Fe',
  province: 'Santa Fe'
}];
function getInitials(name: string) {
  return name.split(' ').map(p => p[0]).slice(0, 2).join('').toUpperCase();
}
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [current, setCurrent] = useState(people[0]);
  useEffect(() => {
    let hideTimer: ReturnType<typeof setTimeout>;
    const showPopup = () => {
      const random = people[Math.floor(Math.random() * people.length)];
      setCurrent(random);
      setIsVisible(true);
      hideTimer = setTimeout(() => setIsVisible(false), 5000);
    };
    const initialTimer = setTimeout(showPopup, 8000);
    const intervalTimer = setInterval(showPopup, 22000);
    return () => {
      clearTimeout(initialTimer);
      clearTimeout(hideTimer);
      clearInterval(intervalTimer);
    };
  }, []);
  return <AnimatePresence data-id="element-27">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="fixed bottom-4 left-4 md:bottom-8 md:left-8 z-50 bg-white rounded-lg shadow-2xl border border-slate-200 overflow-hidden w-[300px]" data-id="element-28">
          {/* Green verified header */}
          <div className="bg-emerald-500 flex items-center justify-between px-3 py-1.5" data-id="element-29">
            <div className="flex items-center gap-1.5 text-white font-bold text-xs tracking-wide" data-id="element-30">
              <Check className="w-3.5 h-3.5" strokeWidth={3} data-id="element-31" />
              COMPRA VERIFICADA
            </div>
            <button onClick={() => setIsVisible(false)} className="text-white/90 hover:text-white transition-colors" aria-label="Cerrar" data-id="element-32">
              <X className="w-3.5 h-3.5" strokeWidth={3} data-id="element-33" />
            </button>
          </div>

          {/* Body */}
          <div className="flex items-center gap-3 px-3 py-3" data-id="element-34">
            <div className="w-10 h-10 rounded-full bg-slate-800 text-white flex items-center justify-center font-bold text-sm flex-shrink-0" data-id="element-35">
              {getInitials(current.name)}
            </div>
            <div className="min-w-0" data-id="element-36">
              <p className="font-bold text-slate-800 text-sm leading-tight truncate" data-id="element-37">
                {current.name}
              </p>
              <p className="text-slate-500 text-xs leading-tight truncate" data-id="element-38">
                {current.city}, {current.province}
              </p>
              <p className="text-slate-400 text-xs leading-tight mt-0.5" data-id="element-39">
                compró el KIT · hace unos minutos
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}